import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import classes from './tabs.module.scss';
import accountHelpers from '../../../../../utils/accountHelpers';
import { deleteScriptData, getPatientScriptsRequest } from '../../../../../store/actions/script';
import Pagination from '../../../../_common/Pagination/Pagination';
import StatusField from '../../../../_common/StatusField/StatusField';
import Loader from '../../../../_common/Loader/Loader';
import Info from '../../../../_common/Info/Info';
import Button from '../../../../_common/Form/Buttons/Button';
import api from '../../../../../api/api';
import Modal from '../../../../_common/Modal/Modal';

const limitCounts = [
  {
    id: 0,
    count: 50,
  },
  {
    id: 1,
    count: 75,
  },
  {
    id: 2,
    count: 100,
  },
  {
    id: 3,
    count: 125,
  },
];

const header = ['Process On', 'Physician', 'Medication', 'Status'];

// let firstLoad = true;

function Prescriptions() {
  const isAdmin = accountHelpers.isInOneOfRoles(['Admin', 'Pharmacy']);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { patientScriptData, patientScriptTotalPage, requestStatus } = useSelector((store) => store.script);
  const { patient: { allergies, conditions, patientWarning } } = useSelector((store) => store.patients);

  const { patientId } = useParams();

  const [requestData, setRequestData] = useState({
    patientId,
    userId: accountHelpers.getUser().id,
    page: 1,
    limit: 50,
  });
  const { page, limit } = requestData;

  const [isOpenModal, setIsOpenModal] = useState({ scriptId: null, open: false });
  const { scriptId, open } = isOpenModal;

  const [loading, setLoading] = useState(false);

  const [firstLoad, setFirsLoad] = useState(true);

  useEffect(() => {
    (async () => {
      setFirsLoad(true);

      await dispatch(getPatientScriptsRequest(requestData));

      setFirsLoad(false);
    })();
  }, [requestData]);

  const onChangePageData = async (path, count) => {
    if (path === 'limit') {
      setRequestData((prev) => ({ ...prev, [path]: count, page: 1 }));
    } else {
      setRequestData((prev) => ({ ...prev, [path]: count }));
    }
  };

  const deleteScriptClick = async (id) => {
    setLoading(true);

    dispatch(deleteScriptData(id));

    await api.deleteScript(id);

    setLoading(false);

    setIsOpenModal({ scriptId: null, open: false });
  };

  return (
    <div className={classes.prescript_wrapper}>

      {requestStatus === 'request' && firstLoad && (
      <Loader className={classes.loader_wrapper} />
      )}

      {requestStatus === 'success' && (
        <>
          {!patientScriptData.length
            ? <div className={classes.notResult}>No Data Found</div>

            : (
              <>
                <div className={classes.table_wrapper}>
                  <div>
                    {requestStatus === 'request' && (
                      <Loader className={classes.loader_wrapper} />
                    )}

                    <table>
                      <thead>
                        <tr>
                          {header.map((h) => (
                            <th key={h}>{h}</th>
                          ))}
                          {isAdmin && <th>Delete</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {patientScriptData.map((d) => (
                          <tr key={`${d.id}`}>
                            <td onClick={() => navigate(`/scripts/${d.id}`)}>
                              {moment(d.processedOn).format('MM/DD/YYYY')}
                            </td>
                            <td onClick={() => navigate(`/scripts/${d.id}`)}>
                              {d.Physician?.firstName ? `${d.Physician?.firstName} ${d.Physician?.lastName}` : ' - '}
                            </td>
                            <td onClick={() => navigate(`/scripts/${d.id}`)}>
                              {d.Product.name}
                            </td>
                            <td onClick={() => navigate(`/scripts/${d.id}`)}>
                              <StatusField status={d.status} />
                            </td>
                            {isAdmin && (
                            <td>
                              <button
                                className={classes.delete_button}
                                type="button"
                                onClick={() => setIsOpenModal({ scriptId: d.id, open: true })}
                              >
                                Delete
                              </button>
                            </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <Pagination
                    onChange={onChangePageData}
                    limit={+limit}
                    limitCounts={limitCounts}
                    page={+page - 1}
                    totalPage={+patientScriptTotalPage}
                  />
                </div>

                <div className={classes.textarea_wrapper}>
                  <Info
                    title="Co-morbid Conditions"
                  >
                    {conditions}
                  </Info>

                  <Info
                    title="Co-morbid Conditions"
                  >
                    {allergies}
                  </Info>

                  <Info
                    title="Patient Warning"
                    patientWarning
                  >
                    {patientWarning || 'None'}
                  </Info>
                </div>
              </>
            )}
        </>
      )}

      <Modal open={open} onClose={() => setIsOpenModal({ scriptId: null, open: false })}>
        <div className={classes.prescript_modal_wrapper}>
          <h2>Will you like to delete this entry</h2>

          <div>
            <Button
              title="NO"
              onClick={() => setIsOpenModal({ scriptId: null, open: false })}
              clearButton
            />

            <Button
              title="YES"
              onClick={() => deleteScriptClick(scriptId)}
              loading={loading}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Prescriptions;
